var SDK_VERSION = '7.28.1';
export { SDK_VERSION };